module.exports = __webpack_public_path__ + "static/media/paredes_vivas_1.34433152.jpg";